import moment from 'moment'

export default {
  "entityName": "siterequest",
  "pagination": {
    "rowsPerPage": 10,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      value: '_site',
      text: 'Site',
      render: item => `${item.site.city} - ${item.site.name}`,
      readonly: true,
    },
    // {
    //     value: '_pharma',
    //     text: 'Pharmacy',
    //     deps: ['site'],
    //     small: true,
    //     render: item => item.pharmacy.name,
    //     readonly: true
    // },
    // {
    //     value: '_ref',
    //     text: 'Reference',
    //     deps: ['site'],
    //     render: ({ reference }) => `${reference.name} ${reference.surname}`,
    //     readonly: true,
    //     small: true
    // },
    {
      value: 'request_date',
      text: 'Insert Date',
      mini: true,
      readonly: true,
      render: item => moment(item.request_date).format('YYYY-MM-DD'),
      type: 'date' //issue 257 services cambiato datetime con date
    },
    {
              text: 'Requested Date',
              value: 'status_requested_date',
              render: item => item.status_requested_date ? moment(item.status_requested_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=> !(state.user.role === 'Administrator' || state.user.role === 'EMN User') ,
              visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'REQUESTED' || item.status === 'CONFIRMED' ||item.status === 'SENT'|| item.status === 'RECEIVED' || item.status === 'CANCELED'),
              validators: [
                    (field, value, item) => {
                      if (!item.canceling && !value) {
                        return 'Requested Date is required'
                      }
                      return true
                    },
                ]
    },
    {
              text: 'Confirmed Date',
              value: 'status_confirmed_date',
              render: item => item.status_confirmed_date ? moment(item.status_confirmed_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=> !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'CONFIRMED' || item.status === 'SENT' || item.status === 'RECEIVED' || item.status === 'CANCELED'),
              validators: [
                    (field, value, item) => {
                      if (!item.canceling && !value) {
                        return 'Confirmed Date is required'
                      }
                      return true
                    },
                ]
    },
    {
              text: 'Sent Date',
              value: 'status_sent_date',
              render: item => item.status_sent_date ? moment(item.status_sent_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'SENT'|| item.status === 'RECEIVED' || item.status === 'CANCELED'),
              validators: [
                    (field, value, item) => {
                      if (!item.canceling && !value) {
                        return 'Sent Date is required'
                      }
                      return true
                    },
                ]
    },
    {
              text: 'Canceled Date',
              value: 'status_canceled_date',
              render: item => item.status_canceled_date ? moment(item.status_canceled_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=> !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && item.status === 'CANCELED',
              validators: [
                    (field, value, item) => {
                      if (!item.canceling && !value) {
                        return 'Canceled Date is required'
                      }
                      return true
                    },
                ]
    },
    {
              text: 'Received Date',
              value: 'status_received_date',
              render: item => item.status_received_date ? moment(item.status_received_date).format('YYYY-MM-DD'):null,
              filtertofrom: true,
              'type': 'datetime',
              readonly: (item,state)=> !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
              visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && item.status === 'RECEIVED',
              validators: [
                    (field, value, item) => {
                      if (!item.canceling && !value) {
                        return 'Received Date is required'
                      }
                      return true
                    },
                ]
    },
    {
      "value": "n_patients",
      "text": "N patients",
      "type": "number",
      mini: true,
      "validators": [
        "required",
        "number"
      ],
      readonly: true,
    },        
    {
      mini: true,
      value: 'response_eta',
      text: 'Estimated Time of Arrival',
      type: 'datetime',
      min: true,
      readonly: (item,state)=>(state.user.role === 'Administrator' || state.user.role === 'EMN User')? false : true,
      visible: (item, state) => (state.user.role !== 'Site' || item.status === 'SENT') && item.status !== 'NEW' && item.status !== 'REQUESTED' && item.status !== 'SPLITTED' && item.status !== 'CANCELED',
      validators: [
                    (field, value, item) => {
                      if (!item.canceling && !value) {
                        return 'Estimated Time Date is required'
                      }
                      return true
                    },
                ]
    },
    {
      "value": "response_pdf",
      "text": "Response PDF",
      type: 'file',
      visible: (item, state) => item.status === 'SENT' || item.status === 'IMPORTED' || (item.status === 'RECEIVED' && (state.user.role === 'Administrator' || state.user.role === 'EMN User')),
      validators: [
        (field, value, item) => {
          if (!item?.canceling && !value) {
            return 'Response PDF is required'
          }
          return true
        },
      ]
    },    
    {
      "value": "response_date",
      "text": "Received date",
      "type": "datetime",
      max: true,
      mini: true,
      readonly: (item, state) =>   item.status !== 'SENT' && (item.status !=='RECEIVED' && (state.user.role === 'Administrator' || state.user.role === 'EMN User') ),
      // readonly: true,
      visible: item => item.status === 'SENT' || item.status === 'RECEIVED' ,
      validators: [
          (field, value, item) => {
            if (!item.canceling && !value) {
              return 'Received date is required'
            }
            return true
          },
      ]
    },        
    {
      "value": "urgent",
      "text": "Urgent",
      "type": "check",
      mini: true,
      readonly: true,
      visible: item => item.urgent
    },
    {

      "value": "request_arrival_date",
      "text": "Request arrival date",
      "type": "datetime",
      visible: item => item.urgent,
      readonly: item => !['NEW', 'REQUESTED'].includes(item.status),
      mini: true,
      min: true,
			validators: [
				'required',
				(field, value) => moment().isSameOrBefore(moment(value),'day') || `Can't be in the past`
			]      
    },    
    {
      "value": "urgency_reason",
      "text": "Urgency reason",
      "type": "text",
      readonly: true,
      big: true,
      visible: item => !!item.urgency_reason
    },
    {
      value: 'note',
      text: 'Note',
      type: 'text',
      full: true,
      visible: (item, state) => (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (['NEW', 'REQUESTED', 'CONFIRMED', 'SENT'].includes(item.status) || (['RECEIVED', 'CANCELED', 'LOST'].includes(item.status) && item.note)),
      readonly: item => ['RECEIVED', 'CANCELED', 'LOST'].includes(item.status),
      validators: [
        (field, value, item) => {
          if (item.canceling && !item.note) {
            item.canceling = false
            return 'Note required if request is canceled!'
          }
          return true
        },
      ]
    },
    {
      "value": "protocol_id",
      "text": "Protocol",
      "type": "autocomplete",
      "table": {
        "sortable": true
      },
      "title": "name",
      "subtitle": "name",
      "visible": false,
      "filter": null
    },
    {
      "value": "reference_pharmacy_id",
      "text": "Reference",
      "type": "autocomplete",
      "title": "name",
      "subtitle": "name",
      "visible": false,
      "filter": null
    },
    {
      "value": "site_id",
      "text": "Site",
      "type": "autocomplete",
      "title": "name",
      "subtitle": "name",
      "visible": false,
      "filter": null
    }
  ],
  "actions": [
    "upsert"
  ]
}
